import React from "react";

import { LayoutMain } from "@unisearch/theme/layout";
import { TermsConditions, TermsHero } from "@modules/study/terms";

const PrivacyPolicy = () => {
  return (
    <LayoutMain
      title="Privacy Policy"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/privacy-policy`}
    >
      <TermsHero title={"Privacy Policy"} />
    </LayoutMain>
  );
};

export default PrivacyPolicy;
